import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { PackageContent, PimProductInfo, ProductsService, TechnicalAttribute } from '../../services/products.service';
import { ProductDetailsDialogComponent } from './product-details-dialog/product-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-product-details',
    standalone: true,
    imports: [MatIcon, MatIconButton, MatTooltip],
    templateUrl: './product-details.component.html',
    styleUrl: './product-details.component.scss',
})
export class ProductDetailsComponent {
    @Input() productDescription: string;
    @Input() material: string;
    @Input() productDetails: string[];

    constructor(private productsService: ProductsService, private dialog: MatDialog) {}

    public getProductDetails() {
        this.productsService
            .getMaterialInfos(
                [this.material],
                this.productDetails,
                [...(this.productDetails.length ? ['attributes'] : []), 'references'],
                false,
                false
            )
            .subscribe((response: PimProductInfo[]) => {
                this.openProductDetailsDialog(
                    this.productDescription,
                    response[0].technicalAttributes
                        ? this.sortTechnicalAttributes(this.productDetails, response[0].technicalAttributes)
                        : undefined,
                    response[0].productReferences && response[0].productReferences.packageContents
                        ? response[0].productReferences.packageContents
                        : undefined
                );
            });
    }

    private openProductDetailsDialog(
        description: string,
        technicalAttributes?: TechnicalAttribute[],
        packageContents?: PackageContent[]
    ) {
        this.dialog.open(ProductDetailsDialogComponent, {
            data: {
                description,
                technicalAttributes,
                packageContents,
            },
        });
    }

    private sortTechnicalAttributes(
        details: string[],
        technicalAttributes: TechnicalAttribute[]
    ): TechnicalAttribute[] {
        const orderMap = new Map(details.map((id, index) => [id, index]));
        return technicalAttributes.sort(
            (a, b) =>
                (orderMap.get(a.attributeId) ?? Number.MAX_SAFE_INTEGER) -
                (orderMap.get(b.attributeId) ?? Number.MAX_SAFE_INTEGER)
        );
    }
}
